<template>
    <v-dialog :value="show" persistent width="350">
        <v-card elevation="2" style="border: 2px solid grey">
            <v-card-title>Signature Required</v-card-title>
            <v-card-text class="px-3 pt-0 pb-3">
                <div class="rounded" style="border: 1px solid red">
                    <VueSignaturePad id="signature" ref="signaturePad" width="325px" height="75px" :options="options">
                    </VueSignaturePad>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn small @click="clear">Clear</v-btn>
                <v-btn small @click="undo">Undo</v-btn>
                <v-spacer />
                <v-btn small @click="$emit('cancel')">Cancel</v-btn>
                <v-btn small @click="saveSig" :disabled="empty" :loading="inuse">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: function() {
        return {
            empty: true,
            inuse: false,
            options: {
                penColor: "#2196F3",
                onEnd: this.onStrokeEnd,
            },
        }
    },

    props: {
        show: {
            type: Boolean,
            default: false,
        },

        signature: {
            type: Array
        }
    },

    methods: {
        onStrokeEnd() {
            this.empty = this.$refs.signaturePad.isEmpty()
        },

        clear() {
            this.$refs.signaturePad.clearSignature()
            this.empty = this.$refs.signaturePad.isEmpty()
        },

        undo() {
            this.$refs.signaturePad.undoSignature()
            this.empty = this.$refs.signaturePad.isEmpty()
        },

        saveSig() {
            let self = this

            this.inuse = true

            setTimeout(() => {
                const data = self.$refs.signaturePad.saveSignature()
                const glyphs = self.$refs.signaturePad.toData()
                self.$emit("save", data, glyphs)
            }, 100)
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$nextTick(function() {
                    if (this.$refs.signaturePad) {
                        this.$refs.signaturePad.$refs.signaturePadCanvas.width = 325
                        this.$refs.signaturePad.$refs.signaturePadCanvas.height = 75
                        this.inuse = false
                        if (this.signature) {
                            this.$refs.signaturePad.fromData(this.signature)
                        }
                        else {
                            this.clear()
                        }
                    }
                })
            }
        },
    }
}
</script>